module.exports = __webpack_public_path__ + "c.no1.6fd4d802.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/c.no1.jpg
// module id = P7aW
// module chunks = 0